import {Component, OnInit} from '@angular/core';
import {Enterprise} from '../../../model/Enterprise';
import {Page} from '../../../../global/util/enum/Page';
import {Constant} from '../../../../global/util/Constant';
import {Partner} from '../../../model/Partner';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {AuthService} from '../../../service/auth/auth.service';
import {Dialog} from '../../../../global/util/Dialog';
import {LocalStorage} from '../../../../global/util/LocalStorage';
import HttpStatusCode from '../../../../global/util/HttpStatusCode';
import {InformType} from '../../../../global/util/enum/InformType';
import {Batchloading} from '../../../model/Batchloading';
import {BatchloadingService} from '../../../service/batchloading.service';
import {DetailBatchLoadingComponent} from '../detail-batch-loading/detail-batch-loading.component';
import {SearchBatchloading} from '../../../model/search/SearchBatchloading';
import {TranslateService} from '@ngx-translate/core';
import {ApplicationService} from '../../../service/application.service';
import {Router} from '@angular/router';
import {DocumentService} from '../../../service/document.service';
import {Pagination} from '../../../../global/util/Pagination';
import {EnterpriseService} from '../../../service/enterprise.service';
import {EnterpriseDataService} from '../../../service/data/enterprise-data.service';

@Component({
  selector: 'app-list-batch-loading',
  templateUrl: './list-batch-loading.component.html',
  styleUrls: ['./list-batch-loading.component.css']
})
export class ListBatchLoadingComponent implements OnInit {

  public title = 'TITLE.DOCUMENTS-UPLOADED';
  public batchloadings: Batchloading[] = [];
  public enterprises: Enterprise[] = [];
  public page: any = {};
  public links: any = {};
  public enumPage = Page;
  public loading: boolean;
  public ROLE_SUPERADMIN = Constant.ROLE_SUPERADMIN;
  public ROLE_PARTNER = Constant.ROLE_PARTNER;
  public partners: Partner[] = [];
  public searchBatchloading = new SearchBatchloading();
  pageNumber: any;
  pageNumbers: any[] = [];

  constructor(public sieCredentialService: BatchloadingService,
              private modalService: NgbModal,
              public authenticationService: AuthService,
              private applicationService: ApplicationService,
              private documentService: DocumentService,
              private enterpriseService: EnterpriseService,
              private enterpriseDataService: EnterpriseDataService,
              private router: Router,
              public translate: TranslateService) {
    Dialog.createInstance(modalService);
    this.loadDefaultData();
  }

  ngOnInit() {
    this.pageNumbers = Pagination.getNumbers();
    this.pageNumber = this.pageNumbers[Constant.ZERO_INDEX].value;
  }

  private loadDefaultData() {
    this.enterprises = LocalStorage.getDefaultEnterprise();
    this.searchBatchloading.enterpriseId = this.enterprises[Constant.ZERO_INDEX].id;
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.partners = LocalStorage.getPartnersExtra();
      this.searchBatchloading.partnerId = this.partners[0].id;
      this.getAllEnterprisesBy();
    } else if (this.hasRole(this.ROLE_PARTNER)) {
      this.searchBatchloading.partnerId = LocalStorage.getPartnerId();
      this.getEnterprisesByPartner(this.searchBatchloading.partnerId);
    } else {
      this.searchBatchloading.partnerId = LocalStorage.getPartnerId();
      this.searchBatchloading.enterpriseId = LocalStorage.getEnterpriseIdView();
    }
    this.search();
  }

  public loadBatchLoadings(page: Page, partnerId?: number, enterpriseId?: number): void {
    partnerId = partnerId ? partnerId : 0;
    enterpriseId = enterpriseId ? enterpriseId : 0;
    let url;
    switch (page) {
      case Page.First:
        url = Constant.ROOT_API_V1.concat('/batchloadings/search?',
          'partner=', String(partnerId),
          '&enterprise=', String(enterpriseId),
          '&size=', this.pageNumber, '&sort=id,desc');
        break;
      case Page.Previous:
        url = this.links.prev.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Next:
        url = this.links.next.href.replace('http', Constant.SCHEMA);
        break;
      case Page.Last:
        url = this.links.last.href.replace('http', Constant.SCHEMA);
        break;
      default:
        url = this.links.self.href.replace('http', Constant.SCHEMA);
        break;
    }
    this.getBatchloadings(url);
  }

  private getBatchloadings(url: string) {
    this.loading = true;
    this.title = this.translate.instant('TITLE.DOCUMENTS-UPLOADED');
    this.sieCredentialService.get(url).subscribe((next: any) => {
      this.loading = false;
      if (next._embedded) {
        this.batchloadings = next._embedded.batchloadings;
      } else {
        this.batchloadings = [];
      }
      this.page = next.page;
      this.links = next._links;
    }, error => {
      this.loading = false;
      if (HttpStatusCode.UNAUTHORIZED === error.error.status) {
        Dialog.show(InformType.Danger, this.title, error.error.message);
      } else {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  public hasRole(name: string): boolean {
    return this.authenticationService.hasRole(name);
  }

  public hasAcknowledgment(batchloading: Batchloading): boolean {
    return batchloading._more.hasAcknowledgment;
  }

  public getDocumentsNotify(batchloading: Batchloading) {
    const url = Constant.ROOT_API_V1
      .concat('/documents/notify/stream?',
        'batchloading=', String(batchloading.id),
        '&documentNumber=', '',
        '&fullname=', '');
    this.getStreamFile(url, 'xlsx');
  }

  public getBatchAcknowledgment(batchloading: Batchloading) {
    const url = Constant.ROOT_API_V1
      .concat('/batchloading/', String(batchloading.id), '/acknowledgment/stream');
    this.getStreamFile(url, 'zip');
  }

  public getStreamFile(url: string, fileExtension: string) {
    this.loading = true;
    this.documentService.download(url).subscribe(next => {
      this.loading = false;
      const control = document.createElement('a');
      control.setAttribute('style', 'display:none;');
      document.body.appendChild(control);
      control.href = window.URL.createObjectURL(next);
      const today = LocalStorage.getTodayString();
      control.download = 'IOFESign-' + today + '-notify.' + fileExtension;
      control.click();
    }, error => {
      this.loading = false;
      const title = 'TITLE.DOWNLOAD-FILE';
      this.processError(title, error);
    });
  }

  private processError(title: string, error: any) {
    const status = error.status;
    if (status) {
      if (HttpStatusCode.UNAUTHORIZED === status) {
        Dialog.show(InformType.Danger, title, error.error.message);
      } else if (HttpStatusCode.FORBIDDEN === status) {
        Dialog.show(InformType.Info, this.translate.instant('TITLE.SESSION-EXPIRED'), this.translate.instant('MESSAGE.SESSION-EXPIRED'));
        this.invalidateSessionAndRedirect();
      } else {
        Dialog.show(InformType.Danger, title);
      }
    } else {
      Dialog.show(InformType.Danger, title, error.error.message);
    }
  }

  private invalidateSessionAndRedirect() {
    this.applicationService.setUserLoggedIn(false);
    this.router.navigate(['login']);
  }


  openDetailModal(batchloading: Batchloading) {
    this.title = this.translate.instant('TITLE.DOCUMENTS-UPLOADED');
    const modalRef = this.modalService.open(DetailBatchLoadingComponent, {
      backdrop: 'static',
      size: 'lg'
    });
    modalRef.componentInstance.batchloading = batchloading;
    modalRef.result.then((result) => {
      if (InformType.Success === result) {
        this.loadBatchLoadings(Page.Self);
        Dialog.show(InformType.Success, this.title);
      } else if (InformType.Danger === result) {
        Dialog.show(InformType.Danger, this.title);
      }
    });
  }

  change(): void {
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      this.getEnterpriseFilteredBy(this.searchBatchloading.partnerId);
    }
  }

  search(): void {
    const partnerId = this.searchBatchloading.partnerId;
    const enterpriseId = this.searchBatchloading.enterpriseId;
    this.loadBatchLoadings(Page.First, partnerId, enterpriseId);
  }

  private getAllEnterprisesBy() {
    this.enterpriseService.getAllEnterprises().subscribe(enterprises => {
      const enterpriseFilter = enterprises.filter(value => value.partnerId === this.searchBatchloading.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterpriseFilter).sort();
      this.enterpriseDataService.setEnterprises(enterprises.sort());
      if (this.enterprises.length > 0) {
        this.searchBatchloading.enterpriseId = this.enterprises[0].id;
      }
    });
  }


  private getEnterprisesByPartner(partnerId: number) {
    this.enterpriseService.getEnterprisesByPartner(partnerId).subscribe(enterprises => {
      this.enterprises = enterprises.sort();
      this.enterpriseDataService.setEnterprises(this.enterprises);
      if (this.enterprises.length > 0) {
        this.searchBatchloading.enterpriseId = this.enterprises[0].id;
      }
    });
  }

  /**
   * Filtra la empresa al seleccionar el partner
   * @param id
   * @private
   */
  private getEnterpriseFilteredBy(id: number): void {
    const enters = this.enterpriseDataService.getEnterprises();
    if (this.hasRole(this.ROLE_SUPERADMIN)) {
      if (id === Constant.ALL_PARTNER_ID) {
        this.enterprises = LocalStorage.getDefaultEnterprise();
      }
      const enterprisesFilter = enters.filter(value => id === value.partnerId);
      this.enterprises = LocalStorage.addEnterprise(enterprisesFilter);
      this.search();
    }
  }
}
